import { LikesConfig, Me, Resource } from '@yandex-int/k-common';
import { getResourceList } from '@yandex-int/k-common/client/api';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { getTeacherClessonLikes } from '@yandex-int/k-common/client/api/defs/get-teacher-clesson-likes';
import { getLikesConfig } from 'platform-components/src/components/app-factory/selectors';
import { getMe } from 'platform-components/src/components/user/selectors';
import { reportMessage } from 'platform-components/src/utils/raven-message';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { getClessonReactionsLoadingStatuses } from 'store/likes/selectors';

import { likesActions } from './actions';

export function* likesSagasWatcher() {
    yield all([takeEvery(likesActions.getClessonReactions, getClessonReactionsSaga)]);
}

function* getClessonReactionsSaga(action: ReturnType<typeof likesActions.getClessonReactions>) {
    const { clessonIds } = action.payload;
    yield loadReactionsResources();
    try {
        const me: Me = yield select(getMe);
        const { result } = yield call(getTeacherClessonLikes, { teacherId: me.id, clessonIds });
        yield put(likesActions.getClessonReactionsSuccess({ reactions: result }));
    } catch (error) {
        console.error(error);
        reportMessage('getClessonReactionsSaga error', error);
    }
}

function* loadReactionsResources() {
    const likesConfig: LikesConfig = yield select(getLikesConfig);
    const resourcesIds = likesConfig.items.map((resource) => resource.resource_id);
    const loadingStatuses: Record<number, LOADING_STATUSES> = yield select(getClessonReactionsLoadingStatuses);

    const shouldBeLoadedIds = resourcesIds.filter((id) => {
        const status = loadingStatuses[id];
        return !status || (status !== LOADING_STATUSES.LOADING && status !== LOADING_STATUSES.SUCCESS);
    });

    if (shouldBeLoadedIds.length) {
        try {
            yield put(likesActions.getResourcesRequest({ resourceIds: shouldBeLoadedIds }));
            const resources: Resource[] = yield call(getResourceList, shouldBeLoadedIds);
            yield put(likesActions.getResourcesRequestSuccess({ resources }));
        } catch (error) {
            console.error(error);
            reportMessage('loadReactionsResources error', error);
        }
    }
}
